import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import styled from "styled-components";
import moment from "moment";
import { useLanguage } from "@/app/utils/LanguageContext";
import { textSize, text_size } from "@/app/utils/MixinSize";
import { PlaceOutlined } from "@mui/icons-material";

type PlacingProps = {
  placing: number;
  totalRunners: number;
  runnerStatus?: string;
  type?: string;
  deadHeat?: boolean;
};

const PlacingGrid = styled(Grid)(() => ({
  [`&`]: {
    color: "#555555",
    width: "fit-content",
    textAlign: "right",
    whiteSpace: "nowrap",
    position: "relative",
    padding: "4px 2px",
  },
  [`&[data-placing="1"]`]: {
    background: "#FFF5C5",
    borderRadius: "4px",
  },
  [`&:is([data-placing="2"], [data-placing="3"])`]: {
    background: "#D1E9FF",
    borderRadius: "4px",
  },
  [`&:is([data-placing="1"], [data-placing="2"], [data-placing="3"]) div`]: {
    color: "#333333",
  },
  [`&[data-ttlrunners]:after`]: {
    color: "#333333",
    minWidth: "13px",
    display: "inline-block",
    fontWeight: 500,
    ...textSize(13),
    textAlign: "left",
    height: "14px",
    lineHeight: "17px",
    content: "''attr(data-ttlrunners)''",
    padding: "4px 0px 4px 6px",
  },
}));
const TextPlace = styled.div`
  width: 100%;
  display: inline-block;
  text-align: left;
  position: relative;
  p {
    color: #555555;
    font-weight: 400;
    line-height: 20px;
    ${text_size(22)}
    span{
      font-weight: 500;
      ${text_size(13)}
      color: #333333;
    }
  }
`;
const PlacingOrdinal = styled("div")((): any => ({
  [`&`]: {
    display: "inline-block",
    color: "#555555",
    fontWeight: 400,
    ...textSize(30),
    textAlign: "center",
    lineHeight: "20px",
    position: "relative",
  },
  [`&:after`]: {
    color: "#333333",
    fontWeight: 500,
    fontSize: "10px", //no need font size +2
    lineHeight: "15px",
    content: "''attr(data-ordinal)''",
    position: "absolute",
    top: "-3px",
  },
  [`&:is([data-type="mobile"])`]: {
    fontSize: 24,
  },
}));
const ResultMsg = styled("text")(() => ({
  [`&`]: {
    color: "#333333",
    fontWeight: 400,
    ...textSize(13),
    verticalAlign: "bottom",
  },
}));

export default function Placing(props: PlacingProps) {
  console.log("placing", props.placing);
  const { state: lang } = useLanguage();
  const { t } = lang;
  var _type = typeof props.type === "undefined" ? "pc" : props.type;

  let statusValue = "";
  if ((props.runnerStatus || "").toUpperCase().indexOf("SCRATCHED") >= 0) {
    statusValue = t("result_scr");
  } else if (props?.placing < 1) {
    statusValue = "-";
  }
  let totalRunners = "/" + props.totalRunners;
  if (props.deadHeat) {
    totalRunners = "/" + props.totalRunners + " " + t("result_dh");
  }
  return (
    <>
      {/^-?\d+$/.test(props?.placing as any) ? (
        props?.placing < 1 ? (
          <PlacingGrid
            data-type={_type}>
            <ResultMsg>{statusValue}</ResultMsg>
          </PlacingGrid>
        ) : (
          <PlacingGrid
            data-placing={props.placing}
            data-ttlrunners={totalRunners}
            data-type={_type}
          >
            <PlacingOrdinal
              data-type={_type}
              data-ordinal={moment
                .localeData()
                .ordinal(props.placing)
                .replace(props.placing?.toString(), "")}
            >
              {props.placing}
            </PlacingOrdinal>
            <ResultMsg>{statusValue}</ResultMsg>
          </PlacingGrid>
        )
      ) : (
        <TextPlace>
          <p>{props?.placing}<span>/{props.totalRunners}</span></p>
        </TextPlace>
      )}
    </>
  );
}
